// Other ways to say each post's words, in four tones, for Bailey's remixes.
// *Asterisks* set the accent (italic in Editorial and Quiet). British
// English, no dashes.
const byTrade = (trade, hair, barber, beauty) => (trade === 'barber' ? barber : trade === 'beauty' ? beauty : hair)

export const TONES = ['warm', 'short', 'playful', 'luxe']

// field -> tone -> lines (functions take the trade)
export const PHRASES = {
  freeSlots: {
    headline: {
      warm: ['Time for *you*.', 'A few chairs are *free*.', 'Room in the diary.'],
      short: ['Chairs free.', 'Free *today*.', 'Spaces open.'],
      playful: [(t) => byTrade(t, 'Your hair called. We *answered*.', 'Your fade called. We *answered*.', 'Your nails called. We *answered*.'), 'Plot twist: we’re *free*.', 'Treat yourself. We’ve got *room*.'],
      luxe: ['An hour, just for *you*.', 'Your seat is *waiting*.', 'A little time, *well spent*.'],
    },
    eyebrow: { warm: ['Last-minute appointments'], short: ['Last-minute'], playful: ['Quick, before they go'], luxe: ['A few spaces'] },
  },
  oneSlot: {
    headline: {
      warm: ['A space just *opened*.', 'One chair. *Yours?*'],
      short: ['One slot left.', (t) => byTrade(t, 'Chair. Waiting.', 'Chair. Waiting.', 'Space. Waiting.')],
      playful: ['Someone’s loss, *your gain*.', 'Quick! One *left*.'],
      luxe: ['A rare opening.', 'Just for *you*.'],
    },
    line: { warm: ['One chair. Your name on it.'], short: ['First to book gets it.'], playful: ['Snooze and you lose it.'], luxe: ['Held for whoever asks first.'] },
  },
  freshWork: {
    headline: {
      warm: [(t) => byTrade(t, 'Fresh out of the chair.', 'Fresh out of the chair.', 'Fresh from the studio.'), 'Made to *last*.'],
      short: ['Fresh.', (t) => byTrade(t, 'New cut. New you.', 'Sharp.', 'Nails done.')],
      playful: [(t) => byTrade(t, 'Hair so good it has *its own fans*.', 'Clean lines. *Big energy*.', 'Nails with *main character energy*.'), 'Obsessed with *this one*.'],
      luxe: ['Quietly *perfect*.', (t) => byTrade(t, 'The art of *the cut*.', 'The art of *the fade*.', 'The art of *the finish*.')],
    },
  },
  beforeAfter: {
    headline: {
      warm: ['A fresh *perspective*.', 'The *difference* a visit makes.'],
      short: ['Before. After.', 'The glow up.'],
      playful: ['Same person. *New energy*.', 'Swipe-worthy *results*.'],
      luxe: ['The *reveal*.', 'Quietly *transformed*.'],
    },
  },
  team: {
    eyebrow: { warm: ['Meet the team'], short: ['Say hello'], playful: ['New face alert'], luxe: ['In the chair'] },
  },
  priceList: {
    title: {
      warm: ['Our *menu*.', 'What we do.'],
      short: ['Prices.', 'The line-up.'],
      playful: ['Treat yourself: *the menu*.', 'Pick your *treat*.'],
      luxe: ['The *treatment* list.', 'Our *services*.'],
    },
  },
  tips: {
    label: { warm: ['A useful little tip'], short: ['Pro tip'], playful: ['Salon secret'], luxe: ['A small ritual'] },
  },
  question: {
    cta: { warm: ['Message us to find your fit'], short: ['Ask us anything'], playful: ['Slide into our DMs'], luxe: ['We’d love to help you choose'] },
  },
  offer: {
    eyebrow: { warm: ['This week only'], short: ['Limited time'], playful: ['Treat yourself'], luxe: ['A little something'] },
  },
  giftVouchers: {
    headline: {
      warm: ['The gift they’ll *actually use*.', 'Give them *time off*.'],
      short: ['Gift it.', 'Vouchers.'],
      playful: ['Better than *socks*.', 'The gift that *glows*.'],
      luxe: ['Something *lovely*.', 'A gift of *time*.'],
    },
  },
  review: {},
  newService: {
    eyebrow: { warm: ['New to the menu'], short: ['Just in'], playful: ['Fresh on the menu'], luxe: ['Now on the menu'] },
    cta: { warm: ['Explore the service, link in bio'], short: ['Book now, link in bio'], playful: ['Be the first to try it, link in bio'], luxe: ['Reserve your first visit, link in bio'] },
  },
}

export const CTAS = {
  warm: ['Book through the link in bio'],
  short: ['Book now, link in bio'],
  playful: ['Tap the link in bio, we’ll do the rest'],
  luxe: ['Reserve through the link in bio'],
}

const plain = (s) => String(s || '').replace(/\*/g, '').trim().toLowerCase()

// Lines in a tone for one field, never the one it already says
export const linesFor = (type, field, tone, trade, current) => {
  const job = PHRASES[type] || {}
  const set = (job[field] && job[field][tone]) || (field === 'cta' ? CTAS[tone] : null) || []
  return set.map(l => (typeof l === 'function' ? l(trade) : l)).filter(l => plain(l) !== plain(current))
}
